import { post, get, delete as remove } from 'axios'

const BASE_URL = 'integrations/slack'

export const connectSlack = code => {
  return post(BASE_URL, { code })
    .then(res => res.data)
    .catch(() => ({})) // slack integration code error - 500
}

export const getSlack = () => {
  return get(BASE_URL)
    .then(res => res.data)
    .catch(() => ({})) // slack integration not found - 404
}

export const deleteSlack = id => {
  return remove(`${BASE_URL}/${id}`)
    .then(res => res.data)
    .catch(() => ({})) // slack integration not found - 404
}

export default {
  connectSlack,
  getSlack,
  deleteSlack,
}
